module.exports = "<div class=\"fadingPanel js-fading-panel\"></div>";